<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.adminUsersRole')"
    resource="admin_users_roles"
    :onFetchData="onFetchData"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class AdminUsersRoles extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'admin_user_email_cont',
        label: this.$t('adminUser.email'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'admin_user_phone_cont',
        label: this.$t('adminUser.phone'),
        renderCell: {
          component: 'input',
        }
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
        sortable: true
      },
      {
        prop: 'admin_user.email',
        label: this.$t('adminUser.email'),
        minWidth: 140,
        renderCell: 'mail'
      },
      {
        prop: 'admin_user.phone',
        label: this.$t('adminUser.phone'),
        minWidth: 120,
      },
      {
        prop: 'role.name',
        label: this.$t('model.role'),
        minWidth: 120,
      },
      {
        prop: 'merchant',
        label: this.$t('model.merchant'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'merchants.show', params: { id: value.id } }}>{value.name}</bean-link>
          } else {
            return <span>/</span>
          }
        },
      },
      {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { type, data }) {
    const merchantRole = this.$root.user.current_role.application.merchant_role

    return [
      // 防止chrome自动填充账号密码
      {
        prop: 'email_placeholder',
        label: 'email',
        renderCell: (h) => <input h={h} />
      },
      {
        prop: 'admin_user.email',
        label: this.$t('adminUser.email'),
        renderCell: {
          component: 'input',
          required: true,
          props: {
            disabled: type === 'edit',
          }
        }
      },
      {
        prop: 'role_id',
        label: this.$t('model.role'),
        width: 150,
        renderCell: {
          component: 'select',
          required: true,
          props: {
            clearable: false,
            filterable: true,
            xRemotePreload: async() => {
              const collection = await this.$request.get('/roles?kind_eq=custom&per_page=999');

              return _.concat([{ label: `${merchantRole.name}（系统）`, value: merchantRole.id }], collection.data.map(({ id, name }) => ({ value: id, label: name })))
            },
          }
        }
      },
      data.role_id === merchantRole.id && {
        prop: 'merchant_id',
        label: this.$t('model.merchant'),
        renderCell: {
          required: true,
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/merchants', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/merchants', { params });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      }
    ].filter(Boolean);
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'admin_users_roles.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'admin_users_roles.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/admin_users_roles', { params: { ...this.$route.query, role_kind_in: ['custom', 'merchant'] } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/admin_users_roles/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {}
    }
  }
}

export const route = [
  {
    path: '/admin_users_roles',
    name: 'admin_users_roles.index',
    component: AdminUsersRoles,
    props: {
      type: 'index',
    }
  },
  {
    path: '/admin_users_roles/new',
    name: 'admin_users_roles.new',
    component: AdminUsersRoles,
    props: {
      type: 'new',
    }
  },
  {
    path: '/admin_users_roles/:id',
    name: 'admin_users_roles.show',
    component: AdminUsersRoles,
    props: {
      type: 'show',
    }
  },
  {
    path: '/admin_users_roles/:id/edit',
    name: 'admin_users_roles.edit',
    component: AdminUsersRoles,
    props: {
      type: 'edit'
    }
  }
]
</script>

<style lang="scss" scoped>
  /deep/ .email_placeholder, /deep/ .password_placeholder {
    position: fixed;
    top: -200%;
    left: -200%;
  }
</style>
